var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const Close = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-close ${className}`} {...other}>
      <g>
        <path d="M13.127 3.227a.5.5 0 010 .707L9.06 8l4.066 4.066a.5.5 0 010 .707l-.354.354a.5.5 0 01-.707 0L8 9.06l-4.066 4.066a.5.5 0 01-.707 0l-.354-.354a.5.5 0 010-.707L6.94 7.999 2.873 3.934a.5.5 0 010-.707l.354-.354a.5.5 0 01.707 0L8.001 6.94l4.065-4.066a.5.5 0 01.707 0l.354.354z" fillRule="evenodd"/>
      </g>
    </Base>);
};
export default Close;
